import "babel-polyfill";
import "intersection-observer";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import createStore from "./store";
import Scenes from "./scenes";
import "./index.css";

const store = createStore();

const renderApp = Component => {
  ReactDOM.render(
    <Provider store={store}>
      <Component />
    </Provider>,
    document.getElementById("root")
  );
};

renderApp(Scenes);

if (module.hot) {
  module.hot.accept(Scenes, () => {
    renderApp(Scenes);
  });
}



// WEBPACK FOOTER //
// ./src/index.js